import { formatDateForDisplay } from "./formatDateForDisplay.js";
const parseDateFromElement = ({
  element
}) => {
  if (element && element.textContent) {
    const dateString = element.textContent.trim();
    const parsedDate = Date.parse(dateString);
    const date = new Date(parsedDate);
    const formattedDate = formatDateForDisplay(date);
    return {
      dayOfWeek: formattedDate.dayOfWeek,
      month: formattedDate.month,
      day: formattedDate.day,
      time: formattedDate.time
    };
  }
  return null;
};
export {
  parseDateFromElement
};
//# sourceMappingURL=parseDateFromElement.js.map
